import { render, staticRenderFns } from "./ServicesCard.vue?vue&type=template&id=2f07bd96&scoped=true&"
import script from "./ServicesCard.vue?vue&type=script&lang=js&"
export * from "./ServicesCard.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCard.vue?vue&type=style&index=0&id=2f07bd96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07bd96",
  null
  
)

export default component.exports